import { render, staticRenderFns } from "./PriceDispay.vue?vue&type=template&id=b2711c14&scoped=true&"
import script from "./PriceDispay.vue?vue&type=script&lang=ts&"
export * from "./PriceDispay.vue?vue&type=script&lang=ts&"
import style0 from "./PriceDispay.vue?vue&type=style&index=0&id=b2711c14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2711c14",
  null
  
)

export default component.exports